import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Fulfillment } from 'services/action';

import { Page, Button } from 'ui/components';

import {
  InformationPlan,
} from './component/section';

import { FormInput, FormItems } from './component/form';

const initialState = {
  isLoading: true,
  data: null,
  form: null,
  items: null,
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const [{ form, items, data }, setState] = React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(Fulfillment.$show(id));

    if (req?.message === 'success') {
       setState((prevState) => ({...prevState, data: req?.data}));
    }
  }

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleItemsChange = (v) => {
    setState((prevState) => ({ ...prevState, items: v }));
  };

  const $handleSubmit = async () => {
    const payload = {
      note: form?.note,
      ...items,
    };

    const submit = await Dispatch(Fulfillment.$update(data?.id, payload));

    if (submit?.message === 'success') {
      History.replace(`/delivery/fulfillment/${submit?.data?.id}`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" className=" bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Perbaharui Fulfillment" />

      <Page.Body className="d-block px-3">
        <div className='row'>
            <div className='col-md-8 col-12'>
              <InformationPlan data={data?.delivery_plan} created />
            </div>
            <div className='col-md-4 col-12'>
              <FormInput data={data} onInputChange={$handleFormChange} />
            </div>
        </div>
        <FormItems data={data} onInputChange={$handleItemsChange}/>

      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/delivery/fulfillment`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;